@if(teamDetails(); as team){
<div class="acc-team-details-dialog-part row h-100">
	<div class="col-lg-6">
		<div class="bg-light rounded shadow-sm d-flex flex-column justify-content-between h-100 p-2">
			<div class="p-2 pt-0">
				<div>
					<div class="d-flex">
						<div class="me-2">Accelerator:</div>
						<div>{{team.accName}}</div>
					</div>
					<div class="d-flex">
						<div class="me-2">Team Name:</div>
						<div>{{team.name}}</div>
					</div>
				</div>

				<div class="mt-3">
					<div>Mentors:</div>
					@if(team.accTeamMentors.length === 0){
					<div>No mentors assigned.</div>
					} @else {
					<ul>
						@for(mentor of team.accTeamMentors; track mentor.accMentorId){
						<li>
							{{mentor.fullName}}
							@if(mentor.dropout){
							<span>(Dropped out: Week {{mentor.dropout.dropoutWeek}})</span>
							}
						</li>
						}
					</ul>
					}
				</div>

				<div class="mt-3">
					<div>Ventures:</div>
					@if(team.accTeamVentures.length === 0){
					<div>No ventures.</div>
					} @else {
					<ul>
						@for(venture of team.accTeamVentures; track venture.accVentureId){
						<li>{{venture.ventureName}}</li>
						}
					</ul>
					}
				</div>

				<div class="mt-3">
					<div class="d-flex">
						<div class="me-2">Meeting Time:</div>
						<div>{{team.meetingTime}}</div>
					</div>
					<div class="d-flex">
						<div class="me-2">Meeting Details:</div>
						<div>{{team.meetingDetails ?? 'N/A'}}</div>
					</div>
					<div class="d-flex flex-column">
						<div class="me-2">Overlapping Meeting Details:</div>
						<ul>
							@for(slot of team.formattedOverlappingMeetingSlots; track $index){
							<li>{{slot}}</li>
							}
						</ul>
					</div>
				</div>

				<div class="mt-3">
					<div class="d-flex">
						<div class="me-2">Last Updated:</div>
						<div>{{team.formattedUpdatedDate}}</div>
					</div>
					<div class="d-flex">
						<div class="me-2">Created:</div>
						<div>{{team.formattedCreatedDate}}</div>
					</div>
				</div>
			</div>

			<div class="m-3">
				<common-button-row [center]="true">
					@if(!team.googleCalendarEventId && !team.googleMeetCode){
					<button class="btn btn-standard" (click)="dialogDataService.scheduleTeamMeeting()">Schedule Team Meeting</button>
					}
					@if(team.googleMeetCode){
					<button class="btn btn-standard" (click)="openTeamMeeting(team.googleMeetCode)">Open Team Meeting</button>
					}
					@if(team.googleCalendarEventId){
					<button class="btn btn-standard" (click)="dialogDataService.updateTeamMeetingInvitees()">Update Invitees</button>
					}
				</common-button-row>
			</div>
		</div>
	</div>

	<div class="col-lg-6">
		<div class="bg-light rounded shadow-sm p-2 d-flex flex-column h-100">
			<readonly-access [readonly]="!dialogDataService.canEdit()"></readonly-access>
			<div class="d-flex flex-column justify-content-between flex-grow-1">
				<div class="d-flex flex-column gap-3">
					<common-text-field [field]="form.name()"></common-text-field>
					<common-text-field [field]="form.googleMeetCode()"></common-text-field>
					<div>
						<div class="d-flex gap-1">
							<common-select-field class="flex-fill" [field]="form.dayIndex()"></common-select-field>
							<common-select-field class="flex-fill" [field]="form.timeIndex()"></common-select-field>
						</div>
					</div>
					<common-text-field [field]="form.meetingDetails()"></common-text-field>
				</div>

				<div class="m-3" [class.d-none]="!dialogDataService.canEdit()">
					@if(!isTimeSelectionValid){
					<div class="text-danger text-center mb-2">Please select both meeting day and time and click Save.</div>
					}
					<common-button-row [center]="true">
						<button class="btn btn-standard" #saveBtn>Save</button>
						<button class="btn btn-standard" (click)="revertChanges()">Revert</button>
					</common-button-row>
				</div>
			</div>
		</div>
	</div>
</div>
}